import React, { useEffect, useRef, useState, lazy, memo } from "react";
import { connect } from "react-redux";

import { emptyString, screenSize } from "../../../constants";
import { screenResize } from "../../../views/shared-screens/constants";

const SideBar = lazy(() => import("./sidebar"));
const SidebarContainerTop = lazy(() => import("./sidebarContainerTop"));

const SidebarContainer = (props) => {
  const { screenType, Element, displayName } = props;
  const [isSidebarExpand, setIsSidebarExpand] = useState(true);
  const [expanded, setExpanded] = useState(false);
  const [brandId, setBrandId] = useState(emptyString);
  const [groupId, setGroupId] = useState(emptyString);
  const [managerId, setManagerId] = useState(emptyString);
  const [locationId, setLocationId] = useState(emptyString);
  const [surveyDashboardOpen, setSurveyDashboardOpen] = useState(true);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const sidebarOpened = useRef(false);

  //Maintain side bar according to screen size
  useEffect(() => {
    const handleWindowResize = () => {
      setWindowWidth(window.innerWidth);
    };
    //Add event listener for screen resize
    window.addEventListener(screenResize, handleWindowResize);

    //Remove event listener for screen resize
    return () => {
      window.removeEventListener(screenResize, handleWindowResize);
    };
  });
  return (
    <div
      className={`d-flex flex-column flex-md-row ${windowWidth > screenSize.TABLET ? "vh-100" : emptyString
        } `}
    >
      <SideBar
        brandId={brandId}
        groupId={groupId}
        managerId={managerId}
        setGroupId={setGroupId}
        locationId={locationId}
        setBrandId={setBrandId}
        setManagerId={setManagerId}
        setLocationId={setLocationId}
        setExpanded={setExpanded}
        expanded={expanded}
        screenType={screenType}
        Element={Element}
        isSidebarExpand={isSidebarExpand}
        setIsSidebarExpand={setIsSidebarExpand}
        sidebarOpened={sidebarOpened}
        windowWidth={windowWidth}
        surveyDashboardOpen={surveyDashboardOpen}
        setSurveyDashboardOpen={setSurveyDashboardOpen}
      />
      <main
        className="main-container w-100 overflow-auto"
        id="main-container"
        data-testid="main-page"
      >
        <SidebarContainerTop
          brandId={brandId}
          groupId={groupId}
          managerId={managerId}
          setGroupId={setGroupId}
          locationId={locationId}
          setBrandId={setBrandId}
          setManagerId={setManagerId}
          setLocationId={setLocationId}
          screenType={screenType}
          setExpanded={setExpanded}
          expanded={expanded}
          storeDetails={props.storeDetails}
          isSidebarExpand={isSidebarExpand}
          setIsSidebarExpand={setIsSidebarExpand}
          sidebarOpened={sidebarOpened}
          displayName={displayName}
          surveyDashboardOpen={surveyDashboardOpen}
          setSurveyDashboardOpen={setSurveyDashboardOpen}
        />
        {React.createElement(props.Element)}
      </main>
    </div>
  );
};
const mapStateToProps = (state) => ({
  profileData: state.individualStoreProfileReducer.profileData,
  locationId: state.individualStoreProfileReducer.locationId,
  brandId: state.individualStoreProfileReducer.brandId,
  storeDetails: state.storesReducer.storeDetails,
});

export default connect(mapStateToProps, null)(memo(SidebarContainer));